export const Why3SVG = () => {
  return (
    <svg
      width="125"
      height="114"
      viewBox="0 0 125 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Why 3 SVG</title>
      <g id="22543f18">
        <g id="3954f8ca">
          <path
            id="710194a9"
            d="M53.5088 15.917C34.7679 21.9577 16.5192 34.9264 15.0948 56.091C13.7972 75.3092 25.9456 92.0962 43.9929 98.1592C62.0477 104.222 84.1296 99.6507 97.3817 85.6379C110.835 71.4089 111.641 49.1555 101.14 33.1217C95.9946 25.2614 89.5214 19.4519 80.4903 16.6702C72.2348 14.1272 62.0999 12.6506 53.7996 15.738C52.4423 16.2452 51.5251 20.5034 53.5088 19.7651C60.0565 17.334 67.9839 18.2438 74.6212 19.7204C81.2584 21.197 87.4109 23.7102 92.3106 28.662C105.041 41.5413 110.716 61.4754 100.365 77.7031C91.0278 92.3498 70.6612 98.4724 54.1427 96.0189C37.6241 93.5654 23.0296 82.8414 18.8385 66.3154C16.4521 56.9113 17.6229 46.3216 23.6486 38.4911C30.5767 29.4898 41.9272 23.5834 52.5318 20.1604C54.0159 19.6831 54.9481 15.4472 53.5013 15.9096L53.5088 15.917Z"
            fill="#343339"
          />
          <path
            id="2845dbe5"
            d="M40.8525 30.1457C34.864 43.7931 38.2945 59.6404 44.0219 72.7956C49.4436 85.2572 58.8551 96.0483 72.8455 98.2409C75.7241 98.6883 75.2617 94.8551 72.6665 94.4524C59.3025 92.3568 51.226 80.1413 46.7887 68.418C42.3514 56.6947 39.9053 43.3232 45.1629 31.3463C46.1324 29.1314 41.8369 27.9009 40.8525 30.1457Z"
            fill="#343339"
          />
          <path
            id="071b858c"
            d="M46.9456 20.9054C62.0174 26.0884 76.2688 36.7826 80.6464 52.8462C82.2796 58.8346 83.6369 65.3153 83.8606 71.5274C84.1664 79.9843 81.4742 88.0609 78.1257 95.7124C77.0668 98.1361 81.1162 97.1591 81.8023 95.593C85.1508 87.9416 87.8654 79.9545 87.9026 71.5125C87.9325 64.4129 86.3962 56.6719 84.3155 49.9079C79.2742 33.5683 65.0153 23.0382 49.4737 17.6986C47.9076 17.1617 44.768 20.1671 46.9456 20.9128V20.9054Z"
            fill="#343339"
          />
        </g>
        <path
          id="b059d717"
          d="M28 74.5C42.5 53.5 52.5 49.5 61.5 49.5C70.5 49.5 76.5 57.5 69 66C61.5 74.5 47.5 58 69 41C86.2 27.4 103.5 22.6667 110 22"
          stroke="url(#c03dd1ef)"
          strokeWidth="5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <linearGradient
          id="c03dd1ef"
          x1="69"
          y1="22"
          x2="69"
          y2="74.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8EEBD2" />
          <stop offset="0.605" stopColor="#4D93DE" />
          <stop offset="1" stopColor="#FFC9BD" />
        </linearGradient>
      </defs>
    </svg>
  );
};
